module.exports = __webpack_public_path__ + "static/picture3-999d655396a1106708e2dd5c7e8e521a.png";